import Sidebar from "./dash-board-sidebar";
import { Outlet } from "react-router";
const UserDashboard = ({}) => {
  return (
    <div>
      <Sidebar>
        <Outlet />
      </Sidebar>
    </div>
  );
};
export default UserDashboard;
